import axios from "axios";
import {
  orderType,
  tablePageSizes,
} from "../../ui-library/CustomTable/constants";
import { getClaims } from "../../../modules/login";
import { handleHttpErrors } from "../../../modules/http";

// Constants
const LOADING_COMMENTS = "LOADING_COMMENTS";
const SET_COMMENTS = "SET_COMMENTS";
const SET_SCREENSHOT = "SET_SCREENSHOT";
export const REFRESH_DATA_COMMENTS = "REFRESH_DATA_COMMENTS";

const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

// Acessors
const getLoading = (state) => state?.loading;
const getComments = (state) => state?.comments;
const getScreenshot = (state) => state?.screenshot;
const getTotalItems = (state) => state?.totalItems;
const getSearchedParams = (state) => state?.searchedParams;

const canViewScreenshot = (state) =>
  getClaims(state, "comments.canViewScreenshot");

// Default state
const initialState = {
  comments: [],
  screenshot: "",
  totalItems: null,
  loading: false,
  searchedParams: {
    page: 0,
    limit: tablePageSizes[0],
    search: "",
    orderBy: "created",
    order: orderType.DESC,
  },
};

export const commentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_COMMENTS:
      return {
        ...state,
        loading: true,
      };
    case SET_COMMENTS:
      const { data, searchedParams } = action;
      return {
        ...state,
        comments: data.data,
        totalItems: data.records,
        searchedParams: searchedParams,
        loading: false,
      };
    case SET_SCREENSHOT:
      return {
        ...state,
        screenshot: action.data,
      };
    case REFRESH_DATA_COMMENTS:
      return {
        ...state,
        totalItems: null,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

const fetchComments = (searchedParams) => (dispatch) => {
  const params = {
    ...searchedParams,
  };

  dispatch({
    type: LOADING_COMMENTS,
  });

  return axios
    .get(`/api/audittrail/comments`, { params })
    .then(({ data }) => {
      dispatch({
        type: SET_COMMENTS,
        data,
        searchedParams,
      });
    })
    .catch((error) => {
      // if statement to avoid to show an error when the request is canceled
      if (error?.message === "cancel") {
        return;
      }

      const defaultMessage = error.response?.data
        ? error.response.data
        : "There was an error while trying to fetch the comments!";

      return handleHttpErrors(error.request?.status, {
        default: defaultMessage,
      });
    });
};

const fetchCommentScreenshot = (key) => (dispatch) => {
  return axios
    .get(`/api/audittrail/comment/image?commentId=${key}`)
    .then(({ data }) => {
      dispatch({
        type: SET_SCREENSHOT,
        data,
      });
    })
    .catch((error) => {
      const defaultMessage = error.response?.data
        ? error.response.data
        : "There was an error while trying to fetch the image!";

      return handleHttpErrors(error.request?.status, {
        default: defaultMessage,
      });
    });
};

const clearScreenshot = () => (dispatch) => {
  dispatch({
    type: SET_SCREENSHOT,
    data: null,
  });
};

export const mapStateToProps = (state) => {
  return {
    comments: getComments(state),
    screenshot: getScreenshot(state),
    totalItems: getTotalItems(state),
    searchedParams: getSearchedParams(state),
    loading: getLoading(state),
    canViewScreenshot: canViewScreenshot(state),
  };
};

export const mapDispatchToProps = {
  fetchComments,
  fetchCommentScreenshot,
  resetState,
  clearScreenshot,
};
